module.exports = __webpack_public_path__ + "static/img/bg-fr.ce08459d.png";